import axiosInstance from '../axiosInterceptor/axiosInstance'

// atob yields a binary string; the bytes have to go through a Uint8Array to survive as a Blob.
const base64ToPdfBlob = (base64) => {
  const binary = window.atob(base64)
  const bytes = new Uint8Array(binary.length)

  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i)

  return new Blob([bytes], { type: 'application/pdf' })
}

// The org's contract awaiting signature (or last signed), with the PDF as a Blob and the
// `documentHash` that acceptance sends back. Readable by the org owner and by a pending kick-off invitee.
const getOrgContract = (orgId, config) =>
  axiosInstance.get(`v1/orgs/${orgId}/contracts/current`, config).then((r) => {
    const { pdfBase64, ...contract } = r.data

    return { ...contract, pdf: base64ToPdfBlob(pdfBase64) }
  })

export default getOrgContract
